import React, { useState, useEffect } from 'react'
import { Editor, EditorState, ContentState, RichUtils, convertToRaw } from 'draft-js'
import htmlToDraft from 'html-to-draftjs'
import draftToHtml from 'draftjs-to-html'
import 'draft-js/dist/Draft.css'
import styleModules from './TextEditor.module.scss'
import wrapField from '../shared/wrapField'

const Field = ({ width, height = 130, label, withToolbar = true, info, style, defaultText, smartSubmit, fieldState, fieldApi, resolvePlaceholder, monospace, ...props }) => {
	const isForm = fieldState && fieldApi

	const stateToHtml = state => {
		const rawContentState = convertToRaw(state.getCurrentContent())
		const markup = draftToHtml(rawContentState)
		return markup
	}
	const getEditorState = (text) => {
		if(!text) {
			return EditorState.createEmpty()
		}
		const blocksFromHtml = htmlToDraft(text)
		 if(!blocksFromHtml?.contentBlocks) {
		 	return EditorState.createEmpty()
		 }
		 const state = ContentState.createFromBlockArray(blocksFromHtml.contentBlocks, blocksFromHtml.entityMap)
		return EditorState.createWithContent(state)
	}

	const [editorState, setEditorState] = useState(() => {
		const text = isForm ? fieldState.value : defaultText
		return getEditorState(text)
	})

	// Update editorState when form field value was updated through formApi
	useEffect(() => {
		const value = fieldState?.value || defaultText
		if(stateToHtml(editorState) !== value) {
			const newState = getEditorState(value)
			setEditorState(newState)
		}
	}, [defaultText || fieldState?.value])

	const onChange = newEditorState => {
		if(props.onChange) {
			props.onChange(stateToHtml(newEditorState))
		}
		setEditorState(newEditorState)
		if(smartSubmit) {
			smartSubmit.delay()
		}
	}
	const onBlur = e => {
		if(props.onBlur) {
			props.onBlur(e)
		}
		if(isForm) {
			fieldApi.setValue(stateToHtml(editorState))
			fieldApi.setTouched()
		}
		if(smartSubmit) {
			smartSubmit.submit(e)
		}
	}

	const changeStyle = newStyle => e => {
		e.preventDefault()
		onChange(RichUtils.toggleInlineStyle(editorState, newStyle))
	}
	const toggleBlockType = blockType => e => {
		e.preventDefault()
		onChange(RichUtils.toggleBlockType(editorState, blockType))
	}

	return (
		<div className={styleModules.container} style={{ ...style, height: `${height}px`, width: `${width}px`, ...monospace && { fontFamily: 'monospace' } }}>
			{withToolbar &&
				<div className={styleModules.toolbar + ' toolbar'}>
					<div onMouseDown={changeStyle('BOLD')}><b>B</b></div>
					<div onMouseDown={changeStyle('ITALIC')}><i>I</i></div>
					<div onMouseDown={changeStyle('UNDERLINE')}><u>U</u></div>
					<div onMouseDown={toggleBlockType('unordered-list-item')}>UL</div>
				</div>
			}
			<Editor
				placeholder={resolvePlaceholder('text_editor')}
				{...props}
				editorState={editorState}
				onChange={onChange}
				onBlur={onBlur}
			/>
		</div>
	)
}

export default wrapField(Field)


